import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Label,
  Input,
  FormGroup
} from 'reactstrap';
import LabelInput from '@src/components/LabelInput/LabelInput';
import { maxLength, multiEmail, required, faxNumber } from '@src/validation';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';
import axiosInstance from '@src/axios-instance';
import Select from 'react-select';
import BillToPartyView from '../BillToPartyView/BillToPartyView';
import UnitView from '../UnitView/UnitView';
import LenderModalForm from '@components/Lenders/LenderModal/LenderModalForm/LenderModalForm';
import EscrowCompanyForm from '@components/EscrowCompanies/EscrowCompanyModal/EscrowCompanyForm/EscrowCompanyForm';
import EOITypes from '@components/EvidenceOfInsurance/Types/Types';

const fieldValidator = {
  invoice_email: [value => maxLength(value, 255), multiEmail],
  email_cc: [value => maxLength(value, 255), multiEmail],
  email_bcc: [value => maxLength(value, 255), multiEmail],
  fax_number: [faxNumber, value => maxLength(value, 255)],
  evidence_of_insurance_pricing_id: [required],
  bill_to_type: [],
  model_id: [],
  pre_pay: [],
  chargeable: []
};

const fieldCompanyValidator = {
  name: [required, value => maxLength(value, 255)],
  contact_name: [value => maxLength(value, 255)],
  phone: [value => maxLength(value, 64)],
  email: [multiEmail, value => maxLength(value, 255)],
  fax: [value => maxLength(value, 64)],
  address_line_1: [value => maxLength(value, 255)],
  address_line_2: [value => maxLength(value, 255)],
  city: [value => maxLength(value, 255)],
  state: [value => maxLength(value, 64)],
  zip_code: [value => maxLength(value, 32)]
};
const fieldLenderValidator = {
  name: [required, value => maxLength(value, 255)],
  lpc: [value => maxLength(value, 64)],
  contact_name: [value => maxLength(value, 255)],
  email: [multiEmail, value => maxLength(value, 255)],
  phone: [value => maxLength(value, 64)],
  fax: [value => maxLength(value, 64)],
  address_line_1: [value => maxLength(value, 255)],
  address_line_2: [value => maxLength(value, 255)],
  city: [value => maxLength(value, 255)],
  state: [value => maxLength(value, 64)],
  zip_code: [value => maxLength(value, 32)]
};

class MailingAddressModal extends React.Component {
  constructor(props) {
    super(props);
    const fields = {};

    Object.keys(fieldValidator).forEach(key => {
      if (key === 'pre_pay') {
        fields[key] = {
          value:
            props.entity[key] !== null
              ? props.entity[key]
              : props.entity.tenant.default_prepay,
          visited: false,
          error: false
        };
      } else {
        fields[key] = {
          value: props.entity[key] !== null ? props.entity[key] : '',
          visited: false,
          error: false
        };
      }
    });

    /*if (fields['bill_to_type'].value === '') {
      fields['bill_to_type'].value = 'escrow-company';
    }*/
    if (fields['evidence_of_insurance_pricing_id'].value === '') {
      const types = EOITypes.find(type => type.key === props.entity.type);
      fields['evidence_of_insurance_pricing_id'].value =
        types !== undefined && types.billable ? 1 : 3;
    }

    const lender = {};
    Object.keys(fieldLenderValidator).forEach(key => {
      lender[key] = {
        value: '',
        visited: false,
        error: false
      };
    });
    fields.lender = lender;

    const escrowCompany = {};
    Object.keys(fieldCompanyValidator).forEach(key => {
      escrowCompany[key] = {
        value: '',
        visited: false,
        error: false
      };
    });
    fields.escrow_company = escrowCompany;

    this.state = {
      ...fields,
      escrow: [],
      lenders: [],
      pricings: [],
      inputValue: '',
      loaded: false,
      newForm: false
    };

    this.loadOptions();
  }

  loadOptions = () => {
    axiosInstance()
      .get(
        `/evidence-of-insurances/billing-options/${this.props.entity.id}.json`
      )
      .then(response => {
        const newState = { loaded: true, ...response.data };
        if (
          this.state.model_id.value !== '' &&
          this.state.bill_to_type.value !== 'homeowner'
        ) {
          let tmp =
            this.state.bill_to_type.value === 'escrow-company'
              ? response.data.billToOptions.find(
                  o => o.id === this.state.model_id.value && o.type === 'Escrow'
                )
              : response.data.billToOptions.find(
                  o => o.id === this.state.model_id.value && o.type === 'Lender'
                );
          let address = this.getAddress(tmp);
          newState.model_id = {
            value: {
              value: tmp.id,
              label:
                tmp.type +
                ' - ' +
                tmp.name +
                ' - ' +
                (tmp.contact_name !== null && tmp.contact_name.length > 0
                  ? tmp.contact_name
                  : ' ') +
                ' - ' +
                address,
              object: tmp
            },
            visited: false,
            error: false
          };
        }

        this.setState(newState);
      })
      .catch(err => {
        console.log(err);
      });
  };

  updateForm = (event, name) => {
    const inputData = {
      value:
        event !== null && event.target !== undefined
          ? event.target.value
          : event === null
          ? ''
          : event,
      visited: true,
      error: false
    };

    for (let i = 0; i < fieldValidator[name].length; i++) {
      const validationMsg = fieldValidator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    const updateState = {
      [name]: inputData
    };
    if (name === 'bill_to_type') {
      updateState.model_id = {
        value: '',
        visited: true,
        error: false
      };
      updateState.newForm = '';
    }
    if (name === 'model_id') {
      updateState.newForm = '';
      updateState.bill_to_type = {
        value:
          event.object.type.toLowerCase() === 'lender'
            ? 'lender'
            : 'escrow-company',
        visited: true,
        error: false
      };
    }

    this.setState(updateState);
  };

  updateHomeowner = isChecked => {
    const updateState = {
      bill_to_type: {
        value: isChecked ? 'homeowner' : '',
        visited: true,
        error: false
      },
      model_id: {
        value: '',
        visited: true,
        error: false
      },
      newForm: ''
    };
    this.setState(updateState);
  };

  updateNewForm = (event, name) => {
    const isLender = this.state.bill_to_type.value === 'lender';
    const formData = isLender
      ? JSON.parse(JSON.stringify(this.state.lender))
      : JSON.parse(JSON.stringify(this.state.escrow_company));

    const inputData = {
      value:
        event !== null && event.target !== undefined
          ? event.target.value
          : event === null
          ? ''
          : event,
      visited: true,
      error: false
    };

    const validator = isLender ? fieldLenderValidator : fieldCompanyValidator;
    for (let i = 0; i < validator[name].length; i++) {
      const validationMsg = validator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    formData[name] = inputData;
    if (isLender) {
      this.setState({
        lender: formData
      });
    } else {
      this.setState({
        escrow_company: formData
      });
    }
  };

  submitHandler = e => {
    e.preventDefault();
    const formData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;

    Object.keys(fieldValidator).forEach(key => {
      postData[key] =
        formData[key].value.value !== undefined
          ? formData[key].value.value
          : formData[key].value;
      for (let i = 0; i < fieldValidator[key].length; i++) {
        const validationMsg = fieldValidator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }
    });

    // Validate new form
    if (
      this.state.model_id.value === '' &&
      this.state.bill_to_type.value !== 'homeowner' &&
      this.state.bill_to_type.value !== ''
    ) {
      const isLender = this.state.bill_to_type.value === 'lender';
      const newData = isLender
        ? JSON.parse(JSON.stringify(this.state.lender))
        : JSON.parse(JSON.stringify(this.state.escrow_company));
      const validator = isLender ? fieldLenderValidator : fieldCompanyValidator;
      const newPostData = {};

      Object.keys(validator).forEach(key => {
        newPostData[key] =
          newData[key].value.value !== undefined
            ? newData[key].value.value
            : newData[key].value;
        for (let i = 0; i < validator[key].length; i++) {
          const validationMsg = validator[key][i](newData[key].value);
          newData[key].visited = true;
          if (validationMsg !== undefined) {
            newData[key].error = validationMsg;
            isValid = false;
            break;
          } else {
            newData[key].error = false;
          }
        }
      });
      if (isLender) {
        formData['lender'] = newData;
        postData['lender'] = newPostData;
      } else {
        formData['escrow_company'] = newData;
        postData['escrow_company'] = newPostData;
      }
    }

    this.setState({ ...formData });

    if (isValid) {
      this.props.saveEntity(postData, this.props.toggle);
    }
    return false;
  };

  openNewForm = formType => {
    const updateState = {
      model_id: {
        value: '',
        visited: true,
        error: false
      }
    };
    updateState.newForm = formType;
    updateState.bill_to_type = {
      value: formType,
      visited: true,
      error: false
    };

    this.setState({
      ...updateState
    });
  };

  getAddress = lender => {
    const address = [];
    if (lender.address_line_1 !== null && lender.address_line_1.length > 0) {
      address.push(lender.address_line_1);
    }
    if (lender.address_line_2 !== null && lender.address_line_2.length > 0) {
      address.push(lender.address_line_2);
    }
    if (lender.city !== null && lender.city.length > 0) {
      address.push(lender.city);
    }
    if (lender.state !== null && lender.state.length > 0) {
      address.push(lender.state);
    }
    if (lender.zip_code !== null && lender.zip_code.length > 0) {
      address.push(lender.zip_code);
    }
    return address.join(', ');
  };

  render = () => {
    const optionTypes = [];
    const { billToOptions, inputValue } = this.state;
    let address = '';
    if (inputValue.length > 1) {
      Object.keys(billToOptions).map(index => {
        address = this.getAddress(billToOptions[index]);
        if (
          (billToOptions[index].name + address)
            .toLowerCase()
            .indexOf(inputValue.toLowerCase()) !== -1 &&
          optionTypes.length < 1000
        ) {
          optionTypes.push({
            value: billToOptions[index].id,
            label:
              billToOptions[index].type +
              ' - ' +
              billToOptions[index].name +
              ' - ' +
              (billToOptions[index].contact_name !== null &&
              billToOptions[index].contact_name.length > 0
                ? billToOptions[index].contact_name
                : ' ') +
              ' - ' +
              address,
            object: billToOptions[index]
          });
        }

        return false;
      });
    }

    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
        size={'lg'}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>
            {'Edit Billing Options'}
          </ModalHeader>
          <div className={'position-relative'}>
            {this.props.loading && <ProgressBox text={'Submiting ...'} />}
            {this.state.loaded && (
              <ModalBody className={'p-4'}>
                {this.props.errorUnit && (
                  <Alert color={'danger'}>{this.props.errorUnit}</Alert>
                )}
                <Row>
                  <Col xs={12}>
                    <FormGroup check className={'pb-2 float-left mr-3'}>
                      <Label check>
                        <Input
                          style={{ top: '1px' }}
                          type="checkbox"
                          checked={this.state.chargeable.value}
                          onChange={event =>
                            this.updateForm(
                              event.currentTarget.checked ? 1 : 0,
                              'chargeable'
                            )
                          }
                        />{' '}
                        Chargeable
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col xs={6}>
                    <div className={'form-group mb-1'}>
                      <span className={'font-weight-bold'}>Bill To Party</span>
                      <Select
                        value={this.state.model_id.value}
                        options={optionTypes}
                        onInputChange={inputValue =>
                          this.setState({ inputValue })
                        }
                        isDisabled={
                          this.state.bill_to_type.value === 'homeowner'
                        }
                        placeholder={'Type to search...'}
                        onChange={event => this.updateForm(event, 'model_id')}
                      />
                    </div>
                  </Col>

                  <React.Fragment>
                    <Col xs={1} className={'text-center pt-2'}>
                      <label className={'mb-1 d-block'}>&nbsp;</label>
                      or
                    </Col>
                    <Col xs={5} className={'text-center btn-block'}>
                      <label className={'mb-1'}>&nbsp;</label>
                      <UncontrolledDropdown>
                        <DropdownToggle
                          caret
                          color={'primary'}
                          className={'btn-block'}
                          disabled={
                            this.state.bill_to_type.value === 'homeowner'
                          }
                        >
                          Create New
                        </DropdownToggle>
                        <DropdownMenu right>
                          <DropdownItem
                            onClick={() => this.openNewForm('escrow-company')}
                          >
                            Escrow Company
                          </DropdownItem>
                          <DropdownItem
                            onClick={() => this.openNewForm('lender')}
                          >
                            Lender
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </Col>
                  </React.Fragment>

                  <Col xs={12} className={'pb-3'}>
                    <FormGroup check className={'pt-2 float-left mr-3'}>
                      <Label check>
                        <Input
                          style={{ top: '5px' }}
                          type="checkbox"
                          checked={
                            this.state.bill_to_type.value === 'homeowner'
                          }
                          onChange={event =>
                            this.updateHomeowner(event.currentTarget.checked)
                          }
                        />{' '}
                        Bill to Homeowner instead of Escrow Company / Lender
                      </Label>
                    </FormGroup>
                  </Col>

                  {this.state.newForm === 'lender' && (
                    <Col xs={12} className={'pb-2'}>
                      <Card>
                        <CardBody>
                          <LenderModalForm
                            state={this.state.lender}
                            updateForm={this.updateNewForm}
                            nameLabel={'Lender Name'}
                            namePlaceholder={'Company - Requestor'}
                          />
                        </CardBody>
                      </Card>
                    </Col>
                  )}

                  {this.state.newForm === 'escrow-company' && (
                    <Col xs={12} className={'pb-2'}>
                      <Card>
                        <CardBody>
                          <EscrowCompanyForm
                            state={this.state.escrow_company}
                            updateForm={this.updateNewForm}
                            nameLabel={'Escrow Company Name'}
                            namePlaceholder={'Company - Requestor'}
                          />
                        </CardBody>
                      </Card>
                    </Col>
                  )}

                  {this.state.model_id.value !== '' && (
                    <Col xs={12} className={'pb-2'}>
                      <Card>
                        <CardBody>
                          <BillToPartyView
                            {...this.state.model_id.value.object}
                            link={true}
                            billToType={this.state.bill_to_type.value}
                          />
                        </CardBody>
                      </Card>
                    </Col>
                  )}
                  {this.state.bill_to_type.value === 'homeowner' && (
                    <Col xs={12} className={'pb-2'}>
                      <Card>
                        <CardBody>
                          <UnitView {...this.props.entity} />
                        </CardBody>
                      </Card>
                    </Col>
                  )}

                  <Col xs={12}>
                    <LabelInput
                      name={'Invoice Email (Separate emails with a comma)'}
                      type={'text'}
                      {...this.state.invoice_email}
                      onChange={event =>
                        this.updateForm(event, 'invoice_email')
                      }
                    />
                  </Col>
                  <Col xs={6}>
                    <LabelInput
                      name={'CC'}
                      type={'text'}
                      {...this.state.email_cc}
                      onChange={event => this.updateForm(event, 'email_cc')}
                    />
                  </Col>
                  <Col xs={6}>
                    <LabelInput
                      name={'BCC'}
                      type={'text'}
                      {...this.state.email_bcc}
                      onChange={event => this.updateForm(event, 'email_bcc')}
                    />
                  </Col>
                  <Col xs={12}>
                    <LabelInput
                      name={'Fax (Separate fax numbers with a comma)'}
                      type={'text'}
                      {...this.state.fax_number}
                      onChange={event => this.updateForm(event, 'fax_number')}
                    />
                  </Col>
                  <Col xs={12}>
                    <div className={'form-group mb-1'}>
                      <span className={'font-weight-bold'}>EOI FEE</span>
                      <select
                        className={'form-control'}
                        value={
                          this.state.evidence_of_insurance_pricing_id.value
                        }
                        onChange={event =>
                          this.updateForm(
                            event,
                            'evidence_of_insurance_pricing_id'
                          )
                        }
                      >
                        {this.state.pricings.map(item => {
                          return (
                            <option
                              value={item.id}
                              key={`evidence_of_insurance_pricing_id-${item.id}`}
                            >
                              ${`${item.rate} (${item.item_name})`}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </Col>

                  <Col xs={12}>
                    <FormGroup check className={'pt-2 float-left mr-3'}>
                      <Label check>
                        <Input
                          style={{ top: '5px' }}
                          type="checkbox"
                          checked={this.state.pre_pay.value}
                          onChange={event =>
                            this.updateForm(
                              event.currentTarget.checked ? 1 : 0,
                              'pre_pay'
                            )
                          }
                        />{' '}
                        Pre-pay required
                      </Label>
                    </FormGroup>
                    <div className={'color-danger font-xs d-block clear'}>
                      * If an EOI is on pre-pay, this EOI will be automatically
                      delivered by the system as soon as the invoice is paid.
                      You do not need to schedule the deliver email for this
                      EOI. Please make sure that recipient emails in this pop up
                      are filled out before you mark this EOI as pre-pay.
                    </div>
                  </Col>
                </Row>
              </ModalBody>
            )}
            <ModalFooter className={'py-4'}>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                Save
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}
export default MailingAddressModal;
